import Caption from '@zenbusiness/common-components/Caption';
import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

const SeriesContainer = styled('div')({
  marginTop: '1.5rem'
});

const SeriesContent = styled('div')({
  marginTop: '1.5rem'
});

export const Series = ({ title, resources, children }) => (
  <SeriesContainer>
    <Text size="xl" bold>{title}</Text>
    <Caption size="lg">{`${resources} resources`}</Caption>
    <SeriesContent>{children}</SeriesContent>
  </SeriesContainer>
);

Series.propTypes = {
  title: PropTypes.string,
  resources: PropTypes.number
};
